import type { Product, ProductGroup } from '../types/index.js';

export function buildStorefrontProductLookup(products: Product[] = []): Map<string, Product> {
  const lookup = new Map<string, Product>();
  for (const product of products) {
    if (!product?.uniqid || lookup.has(product.uniqid)) continue;
    lookup.set(product.uniqid, product);
  }
  return lookup;
}

// Groups reference their products by uniqid; the objects live once in `products`.
export function getStorefrontGroupProducts(
  group: ProductGroup,
  productsOrLookup: Product[] | Map<string, Product> = [],
): Product[] {
  const lookup = productsOrLookup instanceof Map
    ? productsOrLookup
    : buildStorefrontProductLookup(productsOrLookup);
  return (group.product_uniqids ?? []).flatMap((uniqid) => {
    const product = lookup.get(uniqid);
    return product ? [product] : [];
  });
}

export function getMergedStorefrontProducts(products: Product[] = []): Product[] {
  return Array.from(buildStorefrontProductLookup(products).values());
}
